import './LoggedCompanyCustomer.scss'

import { ButtonEmpty } from '@tallink/components-lib'
import { mediaQueries } from '@tallink/components-lib/src/constants/media'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useMedia } from 'react-use'

import { agentLoggedOut, companyLoggedOut, getSerialTickets, selectClubOneTab } from '../../../../../actions/actions'
import { getAgent, getCompany, isAgentLogged } from '../../../../../selectors/selectors'
import { convertAddressToString } from '../../../../../utils/addresses'
import DesktopAgentLoginForm from './DesktopAgentLoginForm'
import LoggedAgent from './LoggedAgent'

export default function LoggedCompanyCustomer() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { agentName } = useSelector(getAgent)
  const agentLogged = useSelector(isAgentLogged)
  const { agentRequired, companyId, address: companyAddress, name: companyName } = useSelector(getCompany)
  const smUp = useMedia(mediaQueries.smUp, true)

  return (
    <div className="logged-company-customer">
      <div className="company-name">{companyName}</div>
      {!smUp && (
        <ButtonEmpty className="sign-out-button" onClick={handleSignOutClick}>
          {t('signOut.link')}
        </ButtonEmpty>
      )}
      <div className="address">{convertAddressToString(companyAddress)}</div>
      {agentRequired && !agentLogged && <DesktopAgentLoginForm companyId={companyId} />}
      {agentRequired && agentLogged && <LoggedAgent agentName={agentName} />}
    </div>
  )

  function handleSignOutClick() {
    dispatch(selectClubOneTab())
    dispatch(companyLoggedOut())
    dispatch(agentLoggedOut())
    dispatch(getSerialTickets())
  }
}
